import { RoutePath } from '../../../constants';
import { DropDownItem } from '../../types';

export const getDropDownList = (isGhostMode: boolean): DropDownItem[] => {
  if (isGhostMode) {
    return [{ title: 'Account Management', url: `${RoutePath.ACCOUNT}/profile` }];
  }

  return [{ title: 'Sign Out', url: '' }];
};
